<app-contact-exceptions-form [form]="form" [propertyId]="contract.buildingId"/>
<div class="modal-footer d-flex justify-content-between">
  <p-button
    (onClick)="cancel()"
    [label]="'CONTRACT.CANCEL' | translate"
    icon="la la-times"
    iconPos="left"
    severity="danger"
  ></p-button>

  <p-button
    [disabled]="isPending()"
    [loading]="isPending()"
    (click)="onSubmit()"
    [label]="'CONTRACT.SUBMIT' | translate"
    icon="la la-check"
    iconPos="left"
    severity="primary"
  ></p-button>
</div>
